"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocations = void 0;
const location_1 = require("@mytmpvpn/mytmpvpn-common/models/location");
const getLocations = () => [
    {
        geonamesId: 3369157,
        city: "Cape Town",
        country: "South Africa",
        countryCode: "za",
        coordinates: { latitude: -33.9249, longitude: 18.4241 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: false,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 1,
                        peanutsPerMinuteMin: 0.1,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.1,
                        peanutsPerMinuteMin: 0.01,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.01,
                        peanutsPerMinuteMin: 0.001,
                    }
                }
            },
        },
    },
    {
        geonamesId: 1819729,
        city: "Hong Kong",
        country: "China",
        countryCode: "hk",
        coordinates: { latitude: 22.3193, longitude: 114.1694 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 2,
                        peanutsPerMinuteMin: 0.2,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.2,
                        peanutsPerMinuteMin: 0.02,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.02,
                        peanutsPerMinuteMin: 0.002,
                    }
                }
            }
        },
    },
    {
        geonamesId: 1880252,
        city: "Singapore",
        country: "Singapore",
        countryCode: "sg",
        coordinates: { latitude: 1.3521, longitude: 103.8198 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 3,
                        peanutsPerMinuteMin: 0.3,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.3,
                        peanutsPerMinuteMin: 0.03,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.03,
                        peanutsPerMinuteMin: 0.003,
                    }
                }
            }
        },
    },
    {
        geonamesId: 2147714,
        city: "Sydney",
        country: "Australia",
        countryCode: "au",
        coordinates: { latitude: -33.8688, longitude: 151.2093 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 4,
                        peanutsPerMinuteMin: 0.4,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.4,
                        peanutsPerMinuteMin: 0.04,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.04,
                        peanutsPerMinuteMin: 0.004,
                    }
                }
            }
        },
    },
    {
        geonamesId: 1642911,
        city: "Jakarta",
        country: "Indonesia",
        countryCode: "id",
        coordinates: { latitude: -6.2088, longitude: 106.8456 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: false,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 5,
                        peanutsPerMinuteMin: 0.5,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.5,
                        peanutsPerMinuteMin: 0.05,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.05,
                        peanutsPerMinuteMin: 0.005,
                    }
                }
            }
        },
    },
    {
        geonamesId: 1850144,
        city: 'Tokyo',
        country: 'Japan',
        countryCode: 'jp',
        coordinates: { latitude: 35.6895, longitude: 139.69171 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 6,
                        peanutsPerMinuteMin: 0.6,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.6,
                        peanutsPerMinuteMin: 0.06,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.06,
                        peanutsPerMinuteMin: 0.006,
                    }
                }
            }
        },
    },
    {
        geonamesId: 1835848,
        city: 'Seoul',
        country: 'South Korea',
        countryCode: 'kr',
        coordinates: { latitude: 37.566, longitude: 126.9784 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 7,
                        peanutsPerMinuteMin: 0.7,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.7,
                        peanutsPerMinuteMin: 0.07,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.07,
                        peanutsPerMinuteMin: 0.007,
                    }
                }
            }
        },
    },
    {
        geonamesId: 1853909,
        city: 'Osaka',
        country: 'Japan',
        countryCode: 'jp',
        coordinates: { latitude: 34.69374, longitude: 135.50218 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 8,
                        peanutsPerMinuteMin: 0.8,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.8,
                        peanutsPerMinuteMin: 0.08,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.08,
                        peanutsPerMinuteMin: 0.008,
                    }
                }
            }
        },
    },
    {
        geonamesId: 1275339,
        city: 'Mumbai',
        country: 'India',
        countryCode: 'in',
        coordinates: { latitude: 19.07283, longitude: 72.88261 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: false,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 9,
                        peanutsPerMinuteMin: 0.9,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 0.9,
                        peanutsPerMinuteMin: 0.09,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.09,
                        peanutsPerMinuteMin: 0.009,
                    }
                }
            }
        },
    },
    {
        geonamesId: 1269843,
        city: 'Hyderabad',
        country: 'India',
        countryCode: 'in',
        coordinates: { latitude: 17.38405, longitude: 78.45636 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 10,
                        peanutsPerMinuteMin: 1,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1,
                        peanutsPerMinuteMin: 0.1,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.1,
                        peanutsPerMinuteMin: 0.01,
                    }
                }
            }
        },
    },
    {
        geonamesId: 6077243,
        city: 'Montreal',
        country: 'Canada',
        countryCode: 'ca',
        coordinates: { latitude: 45.50884, longitude: -73.58781 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 11,
                        peanutsPerMinuteMin: 1.1,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.1,
                        peanutsPerMinuteMin: 0.11,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.11,
                        peanutsPerMinuteMin: 0.011,
                    }
                }
            }
        },
    },
    {
        geonamesId: 2925533,
        city: 'Frankfurt',
        country: 'Germany',
        countryCode: 'de',
        coordinates: { latitude: 50.11552, longitude: 8.68417 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 12,
                        peanutsPerMinuteMin: 1.2,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.2,
                        peanutsPerMinuteMin: 0.12,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.12,
                        peanutsPerMinuteMin: 0.012,
                    }
                }
            }
        },
    },
    {
        geonamesId: 2657896,
        city: 'Zurich',
        country: 'Switzerland',
        countryCode: 'ch',
        coordinates: { latitude: 47.36667, longitude: 8.55 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: false,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 13,
                        peanutsPerMinuteMin: 1.3,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.3,
                        peanutsPerMinuteMin: 0.13,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.13,
                        peanutsPerMinuteMin: 0.013,
                    }
                }
            }
        },
    },
    {
        geonamesId: 2673730,
        city: 'Stockholm',
        country: 'Sweden',
        countryCode: 'se',
        coordinates: { latitude: 59.32938, longitude: 18.06871 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 14,
                        peanutsPerMinuteMin: 1.4,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.4,
                        peanutsPerMinuteMin: 0.14,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.14,
                        peanutsPerMinuteMin: 0.014,
                    }
                }
            }
        },
    },
    {
        geonamesId: 3173435,
        city: 'Milan',
        country: 'Italy',
        countryCode: 'it',
        coordinates: { latitude: 45.46427, longitude: 9.18951 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 15,
                        peanutsPerMinuteMin: 1.5,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.5,
                        peanutsPerMinuteMin: 0.15,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.15,
                        peanutsPerMinuteMin: 0.015,
                    }
                }
            }
        },
    },
    {
        geonamesId: 3104324,
        city: 'Zaragoza',
        country: 'Spain',
        countryCode: 'es',
        coordinates: { latitude: 41.65606, longitude: -0.87734 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 16,
                        peanutsPerMinuteMin: 1.6,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.6,
                        peanutsPerMinuteMin: 0.16,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.16,
                        peanutsPerMinuteMin: 0.016,
                    }
                }
            }
        },
    },
    {
        geonamesId: 2964574,
        city: 'Dublin',
        country: 'Ireland',
        countryCode: 'ie',
        coordinates: { latitude: 53.33306, longitude: -6.24889 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 17,
                        peanutsPerMinuteMin: 1.7,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.7,
                        peanutsPerMinuteMin: 0.17,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.17,
                        peanutsPerMinuteMin: 0.017,
                    }
                }
            },
        },
    },
    {
        geonamesId: 2643743,
        city: 'London',
        country: 'United Kingdom',
        countryCode: 'gb',
        coordinates: { latitude: 51.50853, longitude: -0.12574 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: false,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 18,
                        peanutsPerMinuteMin: 1.8,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.8,
                        peanutsPerMinuteMin: 0.18,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.18,
                        peanutsPerMinuteMin: 0.018,
                    }
                }
            }
        },
    },
    {
        geonamesId: 2988507,
        city: 'Paris',
        country: 'France',
        countryCode: 'fr',
        coordinates: { latitude: 48.85341, longitude: 2.3488 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 19,
                        peanutsPerMinuteMin: 1.9,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 1.9,
                        peanutsPerMinuteMin: 0.19,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.19,
                        peanutsPerMinuteMin: 0.019,
                    }
                }
            }
        },
    },
    {
        geonamesId: 290340,
        city: 'Manama',
        country: 'Bahrain',
        countryCode: 'bh',
        coordinates: { latitude: 26.22787, longitude: 50.58565 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 20,
                        peanutsPerMinuteMin: 2,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 2,
                        peanutsPerMinuteMin: 0.2,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.2,
                        peanutsPerMinuteMin: 0.02,
                    }
                }
            }
        },
    },
    {
        geonamesId: 292223,
        city: 'Dubai',
        country: 'UAE',
        countryCode: 'ae',
        coordinates: { latitude: 25.07725, longitude: 55.30927 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 21,
                        peanutsPerMinuteMin: 2.1,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 2.1,
                        peanutsPerMinuteMin: 0.21,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.21,
                        peanutsPerMinuteMin: 0.021,
                    }
                }
            }
        },
    },
    {
        geonamesId: 4140963,
        city: 'Ashburn',
        country: 'USA',
        countryCode: 'us',
        coordinates: { latitude: 38.89511, longitude: -77.03637 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: false,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 22,
                        peanutsPerMinuteMin: 2.2,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 2.2,
                        peanutsPerMinuteMin: 0.22,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.22,
                        peanutsPerMinuteMin: 0.022,
                    }
                }
            }
        },
    },
    {
        geonamesId: 4509177,
        city: 'Columbus',
        country: 'USA',
        countryCode: 'us',
        coordinates: { latitude: 39.96118, longitude: -82.99879 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: false,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 23,
                        peanutsPerMinuteMin: 2.3,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 2.3,
                        peanutsPerMinuteMin: 0.23,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.23,
                        peanutsPerMinuteMin: 0.023,
                    }
                }
            }
        },
    },
    {
        geonamesId: 5391959,
        city: 'San Francisco',
        country: 'USA',
        countryCode: 'us',
        coordinates: { latitude: 37.77493, longitude: -122.41942 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 24,
                        peanutsPerMinuteMin: 2.4,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 2.4,
                        peanutsPerMinuteMin: 0.24,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.24,
                        peanutsPerMinuteMin: 0.024,
                    }
                }
            }
        },
    },
    {
        geonamesId: 5746545,
        city: 'Portland',
        country: 'USA',
        countryCode: 'us',
        coordinates: { latitude: 45.52345, longitude: -122.67621 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 25,
                        peanutsPerMinuteMin: 2.5,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 2.5,
                        peanutsPerMinuteMin: 0.25,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.25,
                        peanutsPerMinuteMin: 0.025,
                    }
                }
            }
        },
    },
    {
        geonamesId: 3448439,
        city: 'São Paulo',
        country: 'Brazil',
        countryCode: 'br',
        coordinates: { latitude: -23.5475, longitude: -46.63611 },
        providersInfo: {
            [location_1.InfrastructureProvider.Aws]: {
                infraDetails: {
                    ipv6Supported: true,
                },
                pricingRates: {
                    Ultra: {
                        peanutsPerMinuteMax: 26,
                        peanutsPerMinuteMin: 2.6,
                    },
                    Fast: {
                        peanutsPerMinuteMax: 2.6,
                        peanutsPerMinuteMin: 0.26,
                    },
                    Eco: {
                        peanutsPerMinuteMax: 0.26,
                        peanutsPerMinuteMin: 0.026,
                    }
                }
            }
        }
    },
];
exports.getLocations = getLocations;
